<template>
  <div class="ibox systemParams">
    <div class="ibox-content p-xs">
      <el-tabs v-model="activeName" class="el-tabs-card" @tab-click="handleClick">
        <el-tab-pane v-for="item in tabsArr" :key="item.name" :label="item.label" :name="item.name">
        </el-tab-pane>
      </el-tabs>
      <div
        v-for="tab in tabsArr"
        :label="tab.label"
        :name="tab.name"
        :key="tab.name"
      >
        <div v-if="activeName === tab.name">
          <commonPart :reqType="tab.reqType" :height="height" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonPart from "./systemParams/commonPart";
import RCell from "@/components/common/RCell";

export default {
  name: "systemParamsPart",
  components: {
    commonPart,
    RCell,
  },
  data() {
    return {
      height: null,
      activeName: "1",
      size: "small",
      tabsArr: [
        {
          label: "基础参数",
          name: "1",
          reqType: "1",
        },
        // {
        //   label: "地图参数",
        //   name: "2",
        //   reqType: "2",
        // },
        // {
        //   label: "系统设置",
        //   name: "6",
        //   reqType: "3",
        // },
      ],
    };
  },
  methods: {
    handleClick(tab) {
      this.activeName = tab;
      localStorage.setItem("curSysparamsPageTab", tab); // 记录当前参数配置页面选中的tab项，用途：刷新后恢复选中的tab
    },
  },
  mounted() {
    this.height = $("body").height() - $("#app-main").offset().top - 130;
    window.onresize = () => {
      return (() => {
        this.height = $("body").height() - $("#app-main").offset().top - 130;
      })();
    };

    let curSysparamsPageTab = localStorage.getItem("curSysparamsPageTab");
    if (curSysparamsPageTab != null) {
      this.activeName = curSysparamsPageTab;
    }
  },
};
</script>

<style lang="less" scoped>
.systemParams :deep(.el-tabs__header.is-top) {
  margin: 0px !important;
}
</style>

<style lang='less'>
.systemParams {
  
  .zbl-editTable {
    display: inline;
    input {
      border: none;
      outline: none;
      background-color: transparent;
    }
  }
  .zbl-paramValSpan {
    display: inline-block;
    font-weight: bold;
  }
  thead .color-red {
    color: #ff0000;
  }
  .el-button--primary.is-plain {
    border-radius: 52%;
  }
  .el-tabs__header {
    margin: 0;
  }
  .uploadBtnSize {
    padding: 1px 6px;
  }
  .el-radio__input.is-disabled + span.el-radio__label {
    color: #5a5e66;
    font-weight: bold;
  }
}
</style>
